<mat-toolbar class="crud-item-main-toolbar">
  <div class="app-card-title-container">
    <span class="mat-h2 no-margin crud-item-main-toolbar-title">{{ title }}</span>
    <span class="mat-h5 no-margin crud-item-main-toolbar-subtitle">{{ subtitle }}</span>
  </div>
  <span class="flex-spacer"></span>

  <span class="app-form-title-chips-container">
    <span
      *ngIf="pendingChanges"
      class="app-form-title-chip"
      matBadge="!"
      matBadgeColor="warn"
    >
      unsaved
    </span>

    <span class="app-form-title-chip">
      <mat-icon>{{ hasId() ? 'edit' : 'add' }}</mat-icon>
      {{ hasId() ? 'edit' : 'add' }}
    </span>

    <ng-container *ngIf="additionalActions.length > 0">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="crud-table-main-toolbar-icon">more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          *ngFor="let action of additionalActions"
          mat-menu-item
          (click)="onAdditionalActionSelect(action)"
        >
          {{ action.label }}
        </button>
      </mat-menu>
    </ng-container>
  </span>
</mat-toolbar>
<mat-progress-bar *ngIf="isLoading && showLoaderBars" mode="indeterminate"></mat-progress-bar>

@if (longDescription) {
  <div class="mat-body-large long-description">{{ longDescription }}</div>
}

<mat-card>
  <jsonforms
    *ngIf="formData"
    #jsonFormComponent
    [schema]="jsonform.jsonSchema"
    [uischema]="jsonform.uiSchema"
    [renderers]="renderers"
    [(data)]="formData"
    (errors)="onErrors($event)"
    (dataChange)="onDataChange($event)"
  ></jsonforms>

  <mat-card-actions align="end" class="form-actions-container">
    <button
      mat-stroked-button
      *ngIf="!isLoading && enableCancelButton"
      color=""
      (click)="handleUpdateCanceled($event)"
      class="form-action-button form-action-button-reset"
    >
      Cancel
    </button>

    <button
      mat-stroked-button
      *ngIf="!isLoading"
      [disabled]="!pendingChanges"
      color="secondary"
      (click)="handleReset()"
      class="form-action-button form-action-button-reset"
    >
      Reset
    </button>

    <button
      mat-stroked-button
      *ngIf="isLoading"
      color="warn"
      (click)="cancelSave()"
      class="form-action-button form-action-button-reset"
    >
      Cancel
    </button>

    <button
      mat-flat-button
      [disabled]="!pendingChanges || isLoading"
      color="primary"
      (click)="handleSubmit($event)"
      class="form-action-button form-action-button-save"
    >
      {{ isLoading ? 'Saving...' : 'Save' }}
    </button>
  </mat-card-actions>
</mat-card>
